<template>
    <div class="loginBox">
        <div class="login">
            <!--{{ info }}-->
            <h2 style="font-size: 28px">均胜维修系统管理平台</h2>
            <h4>专业 智能 科技 放心托付</h4>
            <form onsubmit="return false">
                <el-input class="loginInput" placeholder="请输入账号" prefix-icon="iconfont u-yonghu1" v-model="account" style="margin-top: 3vh"></el-input>
                <el-input class="loginInput" placeholder="请输入密码" prefix-icon="iconfont u-mima" type="password" v-model="password" @keyup.enter.native="login()"></el-input>
            </form>
            <el-button :loading="loginLoading" @click="login()" type="primary">登录</el-button>
        </div>
        <div class="copyrightInfo">
            <img src="@/assets/imgs/companylogo.png" alt="加载失败" />
            <span>上海联泉智能科技有限公司 提供技术支持</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      info: '',
      account: '',
      password: '',
      loginLoading: false
    }
  },
  mounted () {
    this.info = document.body.offsetHeight
  },
  methods: {
    login () {
      // sessionStorage.setItem("userInfo", JSON.stringify('asdasdsa'));
      // sessionStorage.setItem("authToken", '12312ewaeadw');
      // this.$permission.setAuths( this.formatAuths([]) );
      // this.$router.push({path: "/home"});
      // return
      if (this.account && this.password) {
        this.loginLoading = true
        let options = {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          params: {
            account: this.account,
            password: this.password
          },
          url: this.$api.Login
        }
        this.$http
          .request(options)
          .then(response => {
            this.loginLoading = false
            if (response.status === 100) {
              let userInfo = JSON.parse(JSON.stringify(response.data))
              delete userInfo.userPasswd //删除密码
              sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
              sessionStorage.setItem('authToken', response.data.token)
              this.$store.commit('setUserInfo', userInfo)
              // this.$permission.setAuths(this.formatAuths(response.data.authorities))
              this.$permission.setAuths(response.data.authorities)
              this.$router.push({ path: '/home' })
            }
            this.$message.success(response.message)
          })
          .catch(err => {
            this.loginLoading = false
            this.$message.error('请求失败!')
          })
      } else {
        this.$message.error('账号密码不能为空!')
      }
    },
    formatAuths (data) {
      var auths = []
      let screen = list => {
        list.filter(l => {
          auths.push({
            authCode: l.authCode,
            authId: l.authId,
            authName: l.authName,
            authOrder: l.authOrder,
            authPath: l.authPath,
            authView: l.authView,
            parentId: l.parentId
          })
          if (typeof l.children !== 'undefined' && l.children.length) {
            screen(l.children)
          }
        })
      }
      screen(data)
      return auths
    }
  }
}
</script>

<style scoped lang="scss">
.login {
  width: 58vh;
  .el-input.loginInput {
    margin-top: 2vh;
  }
  .el-button {
    width: 47.5vh;
  }
}
</style>
